import { colours } from "@affinity/constants/StyleConstants";
import { breakpointWidth, rem } from "@affinity/constants/StyleHelpers";
import Button from "@affinity/MobiusOverrides/Button/Button";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

export const QuickOrderButton: React.FC = () => {
    const { isAuthenticated, placeOrderPage, qetQuotePage } = useSelector((state: ApplicationState) => ({
        isAuthenticated: state.context.session.isAuthenticated,
        placeOrderPage: getPageLinkByPageType(state, "AffinityPlaceOrderPage"),
        qetQuotePage: getPageLinkByPageType(state, "AffinityGetQuotePage"),
    }));

    const page = isAuthenticated ? placeOrderPage : qetQuotePage;
    if (!page) {
        return null;
    }

    return (
        <QuickOrderButtonContainer>
            <Button
                variant="primary"
                sizeVariant="medium"
                icon={{
                    src: "ChevronRight",
                    position: "right",
                }}
                id="quickOrder"
                href={page.url}
            >
                {page.title}
            </Button>
        </QuickOrderButtonContainer>
    );
};

const QuickOrderButtonContainer = styled.div`
    display: flex;
    align-items: center;
    @media screen and (max-width: ${breakpointWidth("lg")}) {
        background: ${colours.darkBlue};
        padding: ${rem(20)};
    }
    a {
        text-wrap: nowrap;
    }
`;
